/**
 * @author      hugo@zumper.com (Hugo Pineda)
 * @copyright   Copyright (c) 2021, Zumper
 */

export const isAbsoluteUrl = (url: string) => /^[a-z]{1,6}:.*/i.test(url)

export const rootRelative = (url?: string | null) => {
  if (!url || typeof url !== 'string') {
    return '/'
  }
  // ignoring http://, https://, ftp://, ftps://
  if (isAbsoluteUrl(url)) {
    return url
  } else if (!url?.startsWith?.('/')) {
    return `/${url}`.replace('//', '/')
  }
  return url.replace('//', '/')
}
